import ws from '@api/webservice'
import config from '@app/config'
import { fetchPages } from '@api/utils'

const api = {
  token: (body: TokenPushRequest) => ws<void>(config.ws.notification.token, 'POST', body),
  getPreferences: () =>
    fetchPages<PreferenceNotificationResponse>(
      'preferenceNotificationList',
      config.ws.notification.getPreferences,
      'GET'
    ),
  updatePreferences: (body: PreferenceNotificationListRequest) =>
    ws<void>(config.ws.notification.updatePreferences, 'POST', body),
}

export default api
